import { Campaign } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useTranslation } from '@frontend/i18n';
import { ModalControlModalProps, Text } from '@frontend/design-system';
import { BulkMessagingModal } from './bulk-messaging-modal';

type Props = ModalControlModalProps & {
  campaign?: Campaign;
  onCancel: () => void;
  onDelete: () => void;
  trackingIdPrefix: string;
};

// TODO: Revamp this to use a better modal, like the confirmation one
export const DeleteCampaignModal = ({ campaign, onCancel, onDelete, trackingIdPrefix, ...modalProps }: Props) => {
  const { t } = useTranslation('bulk-messaging');

  return (
    <BulkMessagingModal
      {...modalProps}
      onClose={onCancel}
      title={t('Delete Campaign')}
      trackingIdPrefix={`${trackingIdPrefix}-delete-modal`}
    >
      <Text
        css={{
          textAlign: 'left',
        }}
      >
        {t('Are you sure you want to delete {{campaignName}}? This action cannot be undone.', {
          campaignName: campaign?.title || t('this campaign'),
        })}
      </Text>
      <BulkMessagingModal.ButtonBar
        actionText={t('Delete Campaign')}
        cancelText={t('Cancel')}
        onAction={onDelete}
        onCancel={onCancel}
        trackingId={`${trackingIdPrefix}-delete-modal`}
      />
    </BulkMessagingModal>
  );
};
